require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./revue-des-mdias-1-1-5-5.json") })
        }
      }, "path---revue-des-mdias-1-1-5-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---revue-des-mdias-1-1-5-5!./.cache/json/revue-des-mdias-1-1-5-5.json
// module id = 552
// module chunks = 231608221292675